import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Package, Tag, Layers, Building2 } from "lucide-react";
import Products from "@/pages/Products";
import { Categories, Subcategories, Warehouses } from "@/pages/SimplePages";

const TAB_BY_PATH = {
  "/inventory": "products",
  "/inventory/categories": "categories",
  "/inventory/subcategories": "subcategories",
  "/inventory/warehouses": "warehouses",
};
const PATH_BY_TAB = {
  products: "/inventory",
  categories: "/inventory/categories",
  subcategories: "/inventory/subcategories",
  warehouses: "/inventory/warehouses",
};

export default function Inventory() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const current = TAB_BY_PATH[pathname] || "products";

  return (
    <Tabs
      value={current}
      onValueChange={(v) => navigate(PATH_BY_TAB[v])}
      className="flex flex-col"
    >
      <div className="px-6 md:px-10 pt-6 md:pt-8">
        <TabsList className="bg-card border border-border" data-testid="inventory-tabs">
          <TabsTrigger value="products" data-testid="inv-tab-products" className="data-[state=active]:bg-primary/10 data-[state=active]:text-primary">
            <Package className="w-3.5 h-3.5 mr-1.5" /> Productos
          </TabsTrigger>
          <TabsTrigger value="categories" data-testid="inv-tab-categories" className="data-[state=active]:bg-primary/10 data-[state=active]:text-primary">
            <Tag className="w-3.5 h-3.5 mr-1.5" /> Categorías
          </TabsTrigger>
          <TabsTrigger value="subcategories" data-testid="inv-tab-subcategories" className="data-[state=active]:bg-primary/10 data-[state=active]:text-primary">
            <Layers className="w-3.5 h-3.5 mr-1.5" /> Sub-categorías
          </TabsTrigger>
          <TabsTrigger value="warehouses" data-testid="inv-tab-warehouses" className="data-[state=active]:bg-primary/10 data-[state=active]:text-primary">
            <Building2 className="w-3.5 h-3.5 mr-1.5" /> Almacenes
          </TabsTrigger>
        </TabsList>
      </div>

      <TabsContent value="products" className="mt-0"><Products /></TabsContent>
      <TabsContent value="categories" className="mt-0"><Categories /></TabsContent>
      <TabsContent value="subcategories" className="mt-0"><Subcategories /></TabsContent>
      <TabsContent value="warehouses" className="mt-0"><Warehouses /></TabsContent>
    </Tabs>
  );
}
